<script lang="ts">
  export let small: boolean = false;
</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<label class="label">
  <slot />
</label>
